import React from 'react';
import Navbar from "../parts/Navbar";
import Sidebar from "../parts/Sidebar";
import ControlSidebar from "../parts/ControlSidebar";
import Footer from "../parts/Footer";
import CompanyDocuments from "../parts/CompanyDocuments";

const AdminPage = () => {
    return (
        <div className="wrapper">
            <Navbar/>
            <Sidebar/>
            <ControlSidebar/>
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0">Administrare companie</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content">
                    <div className="container-fluid">
                        <CompanyDocuments/>
                    </div>
                </section>
            </div>
            <Footer/>
        </div>
    );
};

export default AdminPage;
